import { Component, OnInit } from '@angular/core';
import { ServerService } from '../services/server.service';
import { Router } from '@angular/router';
import * as Feather from 'feather-icons';
import Swal from 'sweetalert2'
declare var iziToast:any;
@Component({
  selector: 'app-calleridlist',
  templateUrl: './calleridlist.component.html',
  styleUrls: ['./calleridlist.component.css']
})
export class CalleridlistComponent implements OnInit {
  recordNotFound = false;
  pageLimit = 10;
  paginationData:any ={"info":"hide"};
  offset_count = 0;
 
  costdata:any=[];
  
   constructor(private router:Router,private serverService: ServerService) { }
 
   ngOnInit(): void {
 
    //  this.viewall({})
    this.caller_id_list({});
   }
   procedd(l){
    var s = this;
      iziToast.question({
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: 'once',
        id: 'question',
        zindex: 999,
        title: 'Confirm',
        message: 'Are you sure you want to delete?',
        position: 'center',
        buttons: [
            ['<button><b>YES</b></button>', function (instance, toast) {
     
                instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
     console.log('yes')
    
       s.godelete(l);
     
    
            }, true],
            ['<button>NO</button>', function (instance, toast) {
     
                instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
      console.log('no')
    
            }],
        ]
    
    });
    
    }
     addnewuser(){
 this.router.navigate(['callerid-group-edit'], { state: {page:"add"} });
 
     
 
   }
 
 goedit(l){
    localStorage.setItem('cos',l.caller_group_id); 
 
 this.router.navigate(['callerid-group-edit'], { state: {page:"edit"} });
 
 
 }
 
//  caller_id_lists(){
//   let api_req:any = '{"access_token":"MjI5NCMjIzhkYzEwZGFkYjExYjdjOGNjMTgy","operation":"curlDatas","moduleType":"costsender","api_type":"web","element_data":{"action":"caller_id_view_all","customer_id":"MjI5NA==","limit":10,"offset":0}}';
//   this.serverService.sendServer(api_req).subscribe((response:any)=>{
//     if(response.status==true){

//     }
//   })
//  }
 caller_id_list(data){
     Swal.fire('Loading')
 Swal.showLoading()
 var list_data= this.listDataInfo(data);
 
   let datas:any =new Object();
  let datasend:any = new Object();
     let access_token: any=localStorage.getItem('at');
     let customer_id: any=localStorage.getItem('en');
    
    
 datas.action="caller_id_view_all";
 datas.customer_id = customer_id;
 datas.limit = list_data.limit;
 datas.offset = list_data.offset;
 
 
  datasend.access_token=access_token;
   datasend.operation="curlDatas";
   datasend.moduleType="costsender";
   datasend.api_type="web";
   datasend.element_data = datas;
       this.serverService.sendServer(datasend).subscribe((response: any) => {
 console.log(response)
         if(response.status=="true"){
           Swal.close()
      this.costdata = response.options
    
           }
         else{
           Swal.close()
           
 this.costdata =[];
  
         }
    this.offset_count = list_data.offset;
         this.paginationData = this.serverService.pagination({'offset':response.Offset, 'total':response.Total, 'page_limit' :this.pageLimit });
          console.log(this.paginationData);
                 this.recordNotFound = this.costdata.length == 0 ? true : false;
 
 
       
       }, 
       (error)=>{
           console.log(error);
       });
 
 }
 viewall(data){
     Swal.fire('Loading')
 Swal.showLoading()
 var list_data= this.listDataInfo(data);
 
   let datas:any =new Object();
  let datasend:any = new Object();
     let access_token: any=localStorage.getItem('at');
     let customer_id: any=localStorage.getItem('en');
    
    
 datas.action="view_all";
 datas.customer_id = customer_id;
 datas.limit = list_data.limit;
 datas.offset = list_data.offset;
 
 
  datasend.access_token=access_token;
   datasend.operation="curlDatas";
   datasend.moduleType="costsender";
   datasend.api_type="web";
   datasend.element_data = datas;
       this.serverService.sendServer(datasend).subscribe((response: any) => {
 console.log(response)
         if(response.status=="true"){
           Swal.close()
      this.costdata = response.options
    
           }
         else{
           Swal.close()
           
 this.costdata =[];
  
         }
    this.offset_count = list_data.offset;
         this.paginationData = this.serverService.pagination({'offset':response.Offset, 'total':response.Total, 'page_limit' :this.pageLimit });
          console.log(this.paginationData);
                 this.recordNotFound = this.costdata.length == 0 ? true : false;
 
 
       
       }, 
       (error)=>{
           console.log(error);
       });
 
 }
 
 listDataInfo(list_data){
 console.log(list_data)
   list_data.search_text = list_data.search_text == undefined ? "" : list_data.search_text;
   // list_data.order_by_name = list_data.order_by_name == undefined ? "user.user_id" : list_data.order_by_name;
   // list_data.order_by_type = list_data.order_by_type == undefined ? "desc" : list_data.order_by_type;
   list_data.limit = list_data.limit == undefined ? this.pageLimit : list_data.limit;
   list_data.offset = list_data.offset == undefined ? 0 : list_data.offset;
   return list_data;
 } 
 
 getsearch(searchValue: string): void {  
   console.log(searchValue);
   this.viewall({'search_text':searchValue})
 }
 
 
 
 
 godelete(senderid){
 
   let datas:any =new Object();
  let datasend:any = new Object();
     let access_token: any=localStorage.getItem('at');
     let customer_id: any=localStorage.getItem('en');
    
    //  datas.action="delete_cost_sender";
 datas.action="delete_caller_id_group";
//  datas.customer_id = customer_id;
//  datas.cost_sender_id = senderid.cost_sender_id;
 datas.caller_group_id = senderid.caller_group_id;
 
 
 
  datasend.access_token=access_token;
   datasend.operation="curlDatas";
   datasend.moduleType="costsender";
   datasend.api_type="web";
   datasend.element_data = datas;
       this.serverService.sendServer(datasend).subscribe((response: any) => {
 console.log(response)
         if(response.status=="true"){
          iziToast.success({
           message: "Deleted Successfully",
           position: 'topRight'
       });
     this.caller_id_list({})
    //  this.viewall({})
 
           }
         else{
     iziToast.error({
           message: "Please try again later",
           position: 'topRight'
       });
  
         }
  
 
 
       
       }, 
       (error)=>{
           console.log(error);
       });
 
 }
 
 
 
 
 
 
 
 
 }
 